export const papeletaStatusLabels = {
    N: 'Registrado',
    P: 'Pagado',
    E: 'Espera Reemb.',
    T: 'Reembolsado',
    // R: 'Revertido',
    A: 'Anulado',
}
export const papeletaStatusOptions = Object.entries(papeletaStatusLabels).map(([value, label]) => ({
    value,
    label,
}))
